// src/pages/DealerMap.jsx
import React from "react";

const IFRAME_SRC =
  "https://www.google.com/maps/d/embed?mid=14CUDY8PZwXvUeOjGQhnYa5viP_F-QQA";

export default function DealerMap() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-14">
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
          Preferred Dealer Map
        </h1>
        <p className="mt-3 text-sm sm:text-base text-neutral-400">
          Only certified professionals who know how not to screw up your wrap job.
        </p>
      </div>

      <div className="mt-8 rounded-2xl overflow-hidden border border-neutral-800 aspect-[16/9] bg-neutral-950">
        <iframe
          title="UL Wraps Preferred Dealer Map"
          src={IFRAME_SRC}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <p className="mt-4 text-xs text-neutral-500 text-center">
        Update pins anytime through Google My Maps. This embed auto-updates.
      </p>
    </section>
  );
}
